const GENERAL = 'general';
const EVENTS = 'events';
const CALLS = 'calls';
const BOOKINGS = 'bookings';
const FEATURES = 'features';
const INVENTORY = 'inventory';
const LOCALES = 'locales';
const LOCALE = 'locale';
const MEDIA = 'media';
const ROUND_TABLE = 'roundtable';
const VOD = 'vod';
const EMAIL = 'email';
const OIDC = 'oidc';
const SSO = 'sso';

const SETTINGS_TYPES = Object.freeze({
  GENERAL,
  EVENTS,
  CALLS,
  BOOKINGS,
  FEATURES,
  INVENTORY,
  LOCALES,
  LOCALE,
  MEDIA,
  ROUND_TABLE,
  VOD,
  EMAIL,
  OIDC,
  SSO,
});

module.exports = {
  ...SETTINGS_TYPES,
};
